import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { depositChartData } from 'src/app/shared/charts/datasource';
import { ChartFilterControlsInterface, ReportInputTypes } from 'src/app/shared/models/common';

@Component({
  selector: 'app-gross-earnings',
  templateUrl: './gross-earnings.component.html',
  styleUrls: ['./gross-earnings.component.css']
})
export class GrossEarningsComponent implements OnInit {

  public hideFilters: boolean = false
  grossEarningChartData?: any[] = depositChartData;

  public grossEarningForm: FormGroup
  public grossEarningFormControls: ChartFilterControlsInterface[] = [
    { name: ReportInputTypes.SORT, type: 'SORT', position: 'left' },
    { name: ReportInputTypes.LOAN_PRODUCT, type: 'LOAN_PRODUCT', position: 'right' },
  ]

  public grossEarningSortingOptions: { key: 'name' | 'value', sortingDirection: 'asc' | 'desc' | 'default' } = {
    key: 'name',
    sortingDirection: 'asc'
  }

  constructor() { }

  ngOnInit(): void {
    this.grossEarningChartData = depositChartData.map((item: any) => ({
      name: item.country,
      value: item.gold
    }))
  }

  filterGrossEarnings(ev: any) {
    if (ev.type === 'SORT') {
      const selectedString = ev.value === 'default' ? 'name-default' : ev.value;
      const [key, sortingDirection] = selectedString.split('-');
      this.grossEarningSortingOptions = { key, sortingDirection };
    }
  }

}
